import React from "react";
import { AWS_File_URL } from "../../utils/Constants";
import Swal from "sweetalert2";
import { buildAbsoluteDownloadUrl, download } from "../../utils/FileDownload";
import { ContainerWrapper } from "./GlobalElements/Wrappers";
import { tokens } from "../../public/tokens";

export const downloadBlobFile = (file, fileName, showSwal = true) => {
  return new Promise((resolve, reject) => {
    if (showSwal) {
      Swal.close();
      Swal.fire({
        icon: "info",
        title: "File Downloading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
        showConfirmButton: false,
      });
    }

    try {
      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName ?? file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        // Keep Swal open for at least 2 seconds before showing success message
        setTimeout(() => {
          Swal.fire({
            icon: "success",
            title: "Download Complete",
            timer: 1500,
            showConfirmButton: true
          });
          resolve("Download successful");
        }, 1500);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error while downloading file",
          showConfirmButton: true
        });
        throw new Error("Invalid file type");
      }
    } catch (error) {
      console.error("Download failed:", error);
      setTimeout(() => {
        Swal.fire({
          icon: "error",
          title: "Error while downloading file",
          showConfirmButton: true
        });
        reject(error);
      }, 2000);
    }
  });
};

export const RenderAttachList = (props) => {
    const openFile = (filePath) => {
      const finalURL = buildAbsoluteDownloadUrl(filePath);
      window.open(finalURL, "_blank");
    };

    const fetchIcon = (path) => {
        let ext = path !== undefined && path?.split('.')
        switch (ext[ext?.length - 1]) {
          case 'docx':
            return 'fal fa-file-word';
          case 'zip':
            return 'fal fa-file-archive';
          case 'pdf':
            return 'fal fa-file-pdf';
          case 'xlsx':
            return 'fal fa-file-excel';
          case 'jpg':
          case 'jpeg':
          case 'png':
            return 'fal fa-file-image';
          case 'txt':
            return 'fal fa-file-alt';
          case 'pptx':
            return 'fal fa-file-powerpoint';
          case 'mp4':
          case 'mov':
          case 'avi':
          case 'wmv':
          case 'mkv':
          case 'webm':
              return 'fal fa-video';
          default:
            return 'fal fa-file';
        }
      }
      
return (
  <ContainerWrapper background={tokens.colors.neutral.grey[200]} className="uploded-files-item feed-pad">
    <div
      className="uploded-files-item-txt curser"
      data-toggle="tooltip"
      data-placement="right"
      onClick={() => {
        let fileURL;
        if (
          typeof props.file === "object" &&
          "fileUploadedFrom" in props.file &&
          String(props.file.fileUploadedFrom) === "1" &&
          !/^(?:https?:)?\/\//i.test(props.file.filePath)
        ) {
          fileURL = AWS_File_URL + props.file.filePath;
        } else {
          fileURL = props.filePath;
        }
        openFile(fileURL, props.fileName);
      }}
      title={props.fileName}
    >
      <figure>
        <i className={fetchIcon(props.fileName || props.filePath)}></i>
      </figure>
      <figcaption>
        <h4 className="oneline-ellipsis font12">{props.fileName}</h4>
        {props.size && <p className="font12 hold-show">{props.size}</p>} 
      </figcaption>
    </div>

    {props.showClose ? (
      <button
        onClick={() => {
          props.handleRemoveFile(props);
        }}
        type="button"
        className="btn file-remove-btn"
      >
        <i className="fal fa-times hold-show"></i>
      </button>
    ) : (
      <a
        onClick={(e) => {
          e.stopPropagation();
          if (props.file instanceof File) {
            downloadBlobFile(props.file, props.fileName);
          } else if (typeof props.filePath === "string") {
            let fileURL;
            if (
              typeof props.file === "object" &&
              "fileUploadedFrom" in props.file &&
              String(props.file.fileUploadedFrom) === "1" &&
              !/^(?:https?:)?\/\//i.test(props.file.filePath)
            ) {
              fileURL = AWS_File_URL + props.file.filePath;
            } else {
              fileURL = props.filePath;
            }
            download(fileURL, props.fileName, fileURL.includes(AWS_File_URL) ? false : true);
          }
        }}
        className="btn file-remove-btn rm-box-shadow download-icon"
      >
        <i className="fal fa-download download-icon"></i>
      </a>
    )}
  </ContainerWrapper>
);

}